<template>
  <div class="animated">
    <v-server-table
      id="submission-server-table"
      :ref="ref"
      :columns="table_config.columns"
      :options="table_config.options"
      :theme="theme"
      class="w-100"
    >
      <span slot="pid" slot-scope="{row}">
        <router-link :to="'/submissions/'+row.id">{{ row.pid }}</router-link>
      </span>

      <span slot="sample_count" slot-scope="{row}">
        {{ row.samples ? row.samples.length : 0 }}
      </span>

      <span slot="created_at" slot-scope="{row}">
        {{ row.created_at | moment('L') }}
      </span>
    </v-server-table>
  </div>
</template>

<script>
import Vue from 'vue'
import { ServerTable } from 'vue-tables-2'
import BaseServerTable from '@/components/shared/BaseServerTable'
import SubmissionCollection from '@/collections/lab/SubmissionCollection'

Vue.use(ServerTable)

export default {
  name: 'SubmissionServerTable',
  extends: BaseServerTable,
  props: {
    collection: {
      type: Object,
      default: () => new SubmissionCollection()
    },
    show_columns: {
      type: Array,
      default: () => [
        "pid",
        "project.pid",
        "event_code",
        "turnaround.name",
        "sample_type.name",
        "test_package.name",
        "sample_count",
        "created_at"
      ]
    },
    filterable: {
      type: Array,
      default: () => []
    },
    sortable: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      table_config: _.merge(this.getDefaultTableConfig(), {
        options: {
          headings: {
            pid: "#",
            "project.pid": "Project",
            event_code: "Code",
            "project.customer.full_name": "Customer",
            "turnaround.name": "Turnaround",
            "sample_type.name": "Type",
            "test_package.name": "Package",
            sample_count: "Samples",
            created_at: "Submitted"
          },
          filterable: this.filterable,
          sortable: this.sortable
        }
      }),
      table_data: {
      }
    }
  },
  methods: {
    prepareCollectionFilter (filter) {
      return filter
    }
  }
}
</script>
